export type TFormStatus = {
  status: EStatus;
  step: TSteps;
  formFields: TFormFields;
  leadId?: string;
  priceRange: [number, number];
};

export type TSteps = 0 | 1 | 2;

export type TFormFields = {
  phone: string;
  address: string;
};

export type TFetchFormParams = {
  phone: string;
  address: string;
  leaseTermType: string;
  price: number;
  marketingAccept: boolean;
};

export type TAdditionalFormParams = {
  leadId: string;
  furniture?: string;
  roomsCount?: string;
  repair?: string;
};

export enum EStatus {
  Initial = 'init',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export type TAdditionalFormResponse = { status: string; message: string };

export type TFormResponse = { status: string; message: string; leadId: string };

export type TAdressState = {
  status: EStatus;
  errorMessage?: string;
};
